//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HeroFooter',
  components: {
    ContributorSignUpLink: () => import('@/components/contributor/signup/ContributorSignUpLink.vue'),
  },
};
